module.exports = __webpack_public_path__ + "media/bootstrap-icons/type-italic-ead7669b.svg";